import React from 'react';
import '../css/footer.css'
import logo from '../../images/logo.png'
import Menu from './Menu';
import IscrivitiBox from './IscrivitiBox';
import SocialIcons from './SocialIcon';

function Footer(props) {
    return (
        <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <img src={logo} style={{maxWidth:"100px"}} alt=""/>
                    </div>
                    <div className="col-lg-4 col-md-4 d-none d-md-block">
                        {/* <IscrivitiBox size={"small"}></IscrivitiBox> */}
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-6 col-xs-6" style={{textAlign:"right",fontSize:"25px"}}>
                        <SocialIcons facebook={"https://www.facebook.com/gioiellialfonsi"} instagram={"https://www.instagram.com/gioielliriccardoalfonsi/"}></SocialIcons>
                    </div>
                </div>
                <div className="d-none d-md-block">
                <Menu isFooter={true}></Menu>
                </div>
                
            </div>
        </div>
    );
}

export default Footer;